import axios from "axios";
import { APIClient } from "../apiCore";
import * as url from "../urls";
import {m9sGlobals} from "../../config";
import {PickedMediaSourceFile} from "../../helpers/googlePicker";

const api = new APIClient();

/** The cabinet's connected media sources (Google Drive accounts): {items: MediaSourceType[]}. */
export const getMediaSources = () => {
    return api.get(m9sGlobals.CURRENT_CABINET+url.GET_CONTENT_MEDIA_SOURCES);
};

/** Ask for a Google Picker token; it arrives over the websocket with the same requestId. */
export const requestMediaSourcePickerToken = (sourceUuid: string, requestId: string) => {
    return api.create(m9sGlobals.CURRENT_CABINET+url.REQUEST_CONTENT_MEDIA_SOURCE_PICKER_TOKEN.replace(/:uuid/, sourceUuid), {requestId});
};

/** Import picked files: one pending item per file ({items: MediaSourceImportType[]}). */
export const importMediaSourceFiles = (sourceUuid: string, files: PickedMediaSourceFile[], peerActivityUuid?: string) => {
    return api.create(m9sGlobals.CURRENT_CABINET+url.IMPORT_CONTENT_MEDIA_SOURCE_FILES.replace(/:uuid/, sourceUuid), {
        files,
        peerActivity: peerActivityUuid,
    });
};

/** A background poll: plain axios (same auth and interceptors), without the page loading bar. */
export const getMediaSourceImportStatus = (uuids: string[]): Promise<any> => {
    return axios.get(m9sGlobals.CURRENT_CABINET+url.GET_CONTENT_MEDIA_SOURCE_IMPORT_STATUS, {params: {uuids: uuids.join(',')}});
};
